const featureCategories = [
  {
    name: 'Shoes & Footwear',
    description: 'Organized by style, size, and season — structured for fast filtering',
    image: 'https://readdy.ai/api/search-image?query=Single%20premium%20designer%20sneaker%20placed%20on%20aged%20concrete%20pedestal%20with%20dramatic%20shaft%20of%20sunlight%20from%20above%2C%20urban%20loft%20setting%20with%20exposed%20pipes%2C%20monochromatic%20grey%20and%20white%20palette%20with%20subtle%20warm%20highlights%2C%20artistic%20editorial%20product%20photography%2C%20sculptural%20composition%20emphasizing%20form%20and%20texture&width=800&height=1067&seq=mulebuy-feat-shoes-v2&orientation=portrait',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    wide: true,
  },
  {
    name: 'T-Shirts & Tops',
    description: 'Cotton, blends, and styles — categorized for quick comparison',
    image: 'https://readdy.ai/api/search-image?query=Three%20identical%20premium%20cotton%20tshirts%20in%20olive%20black%20and%20ivory%20displayed%20on%20minimalist%20floating%20shelves%20against%20warm%20charcoal%20wall%2C%20soft%20gallery%20track%20lighting%20from%20above%2C%20sophisticated%20neutral%20color%20story%2C%20high%20end%20retail%20display%20product%20photography%2C%20clean%20architectural%20composition&width=800&height=1067&seq=mulebuy-feat-tshirts-v2&orientation=portrait',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    wide: false,
  },
  {
    name: 'Accessories & More',
    description: 'Bags, belts, perfumes — all tracked in one unified system',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20leather%20watch%20with%20visible%20movement%20alongside%20premium%20sunglasses%20and%20metal%20cufflinks%20arranged%20on%20dark%20walnut%20wood%20valet%20tray%2C%20warm%20desk%20lamp%20illumination%2C%20rich%20mahogany%20and%20brushed%20gold%20accents%2C%20sophisticated%20menswear%20accessory%20product%20photography%2C%20intimate%20refined%20composition&width=800&height=1067&seq=mulebuy-feat-access-v2&orientation=portrait',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    wide: false,
  },
];

export default function FeatureGrid() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 tracking-tight">
            Featured <span className="text-accent-500">&#9829;</span> Categories
          </h2>
          <p className="text-foreground-500 text-base md:text-lg mt-4 max-w-xl mx-auto">
            Popular Mulebuy spreadsheet categories that users organize most frequently
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featureCategories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group relative rounded-xl overflow-hidden cursor-pointer ${
                cat.wide ? 'md:col-span-2 md:row-span-2' : ''
              }`}
              style={{ minHeight: idx === 0 ? '500px' : '380px' }}
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <p className="font-heading text-xl md:text-2xl font-bold text-white">{cat.name}</p>
                <p className="text-white/70 text-sm mt-1.5 max-w-xs">{cat.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}